import { render } from "./Logout.vue?vue&type=template&id=0bdde06c"
import script from "./Logout.vue?vue&type=script&lang=js"
export * from "./Logout.vue?vue&type=script&lang=js"

import "./Logout.vue?vue&type=style&index=0&id=0bdde06c&lang=css"

import exportComponent from "/opt/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__